import BigNumber from 'bignumber.js'
import React, { useCallback, useMemo, useState } from 'react'
import styled from 'styled-components'
import { Button, Modal, Input } from '@pancakeswap-libs/uikit'
import ModalActions from 'components/ModalActions'
import useI18n from 'hooks/useI18n'

interface ModalProps {
  title?: string
  content?: string
  onConfirm?: () => Promise<any>
  onDismiss?: () => void
}

const TheModal: React.FC<ModalProps> = ({ title, content, onConfirm, onDismiss }) => {
  const [pendingTx, setPendingTx] = useState(false)
  const [, setRequested] = useState(false)
  const TranslateString = useI18n()

  const handleSubmit = useCallback(async () => {
    try {
      setRequested(true)
      const txHash = await onConfirm();
      // user rejected tx or didn't go thru
      if (txHash) {
        setRequested(false)
      }
    } catch (e) {
      console.error(e)
    }
  }, [onConfirm, setRequested])

  return (
    <Modal title={title || TranslateString(1232, "Are you sure?")} onDismiss={onDismiss}>
      {
        content ? (
          <div>
            <Announce>
              {content}
            </Announce>
          </div>
        ) : ""
      }
      <ModalActions>
        <Button fullWidth variant="secondary" onClick={onDismiss}>
          {TranslateString(462, 'Cancel')}
        </Button>
        <Button
          fullWidth
          disabled={pendingTx}
          onClick={async () => {
            setPendingTx(true)
            await handleSubmit()
            setPendingTx(false)
            onDismiss()
          }}
        >
          {pendingTx ? TranslateString(488, 'Pending Confirmation') : TranslateString(464, 'Confirm')}
        </Button>
      </ModalActions>
    </Modal>
  )
}

export default TheModal

const Announce = styled.div`
  color: #f41e5b;
  text-align: left;
  max-width: 470px;
  padding: 0px 24px;
`
